export const products = {
  'Amplr Track Competitor': {
    EUR: {
      monthly: {
        price: '9€',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4GBZn8ZsgWEijQTQu5l7'
      },
      annual: {
        price: '90€',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4dBZn8ZsgWEiPURU9inY'
      }
    },
    USD: {
      monthly: {
        price: '$9',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4GBZn8ZsgWEijQTQu5l7'
      },
      annual: {
        price: '$90',
        id: 'prod_T8jXKNgNWSaj5h',
        priceId: 'price_1SCS4dBZn8ZsgWEiPURU9inY'
      }
    },
    mode: 'subscription' as const,
    description: 'Suivi avancé de vos concurrents TikTok',
    features: [
      'Suivi en temps réel des concurrents',
      'Évolution des abonnés (gains/pertes)',
      'Détection des changements de bio',
      'Alertes nouveaux posts',
      'Historique complet des données',
      'Rapports détaillés'
    ],
    included: [true, true, true, true, true, true],
  },
  'Amplr Start': {
    EUR: {
      monthly: {
        price: '74€',
        id: 'prod_S896Pa8cRqmvDF',
        priceId: 'price_1RDsoEBZn8ZsgWEiCOBvt7U8'
      },
      annual: {
        price: '532€',
        id: 'prod_SB5SUe0apELr1c',
        priceId: 'price_1RGjHkBZn8ZsgWEiPJV9hDV2'
      }
    },
    USD: {
      monthly: {
        price: '$74',
        id: 'prod_SB5MxANyMoYzRz',
        priceId: 'price_1RGjBQBZn8ZsgWEi7xId61ph'
      },
      annual: {
        price: '$532',
        id: 'prod_SB5VbCMaExMGlb',
        priceId: 'price_1RGjKaBZn8ZsgWEiL8AUkcll'
      }
    },
    mode: 'subscription' as const,
    description: 'L\'essentiel pour démarrer votre croissance TikTok',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 250 abonnés réels et qualifiés / mois',
      'Interactions automatisées',
      'Statistiques détaillées',
      'Support par email (sous 72 heures)'
    ],
    included: [true, true, true, true, true, true],
  },
  'Amplr Max': {
    EUR: {
      monthly: {
        price: '94€',
        id: 'prod_S89556wcwPMNLm',
        priceId: 'price_1RDsnXBZn8ZsgWEifee21lLs'
      },
      annual: {
        price: '676€',
        id: 'prod_SB5Tfy5Qqpoaqh',
        priceId: 'price_1RGjINBZn8ZsgWEiSBaeb8dD'
      }
    },
    USD: {
      monthly: {
        price: '$94',
        id: 'prod_SB5Mbxdpnrzue',
        priceId: 'price_1RGjBvBZn8ZsgWEiEVOL2w5Z'
      },
      annual: {
        price: '$676',
        id: 'prod_SB5bsqajIo4pgu',
        priceId: 'price_1RGjQfBZn8ZsgWEi4gZVj410'
      }
    },
    mode: 'subscription' as const,
    description: 'L\'offre préférée de 80% de nos clients',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 450 abonnés réels et qualifiés / mois',
      'Interactions automatisées [+ Amplr AI Boost]',
      'Welcome DM automatique',
      'Ajout en amis proches (jusqu\'à 7 500 abonnés)',
      'Statistiques avancées',
      'Support prioritaire (sous 48 heures)'
    ],
    included: [true, true, true, true, true, true, true, true],
    popular: true,
  },
  'Amplr Pro': {
    EUR: {
      monthly: {
        price: '294€',
        id: 'prod_S896R0WlF5XqL7',
        priceId: 'price_1RDsoTBZn8ZsgWEisQR0Cw0h'
      },
      annual: {
        price: '2116€',
        id: 'prod_SB5TX8D9rKncxv',
        priceId: 'price_1RGjIrBZn8ZsgWEiylpKw6m7'
      }
    },
    USD: {
      monthly: {
        price: '$294',
        id: 'prod_SB5N6dbCdo0X4d',
        priceId: 'price_1RGjCSBZn8ZsgWEiwyCZ0XMX'
      },
      annual: {
        price: '$2116',
        id: 'prod_SB5cV7te87bmvq',
        priceId: 'price_1RGjR1BZn8ZsgWEieqbqkbgm'
      }
    },
    mode: 'subscription' as const,
    description: 'Pour les professionnels qui visent l\'excellence',
    features: [
      'Résultats en 24 heures',
      'Croissance garantie ou remboursée',
      'Jusqu\'à 800 abonnés réels et qualifiés / mois',
      'Interactions automatisées [+ Amplr AI Boost]',
      'Welcome DM automatique',
      'Ajout en amis proches (jusqu\'à 7 500 abonnés)',
      'Audit vidéo expert (plan d\'action personnalisé)',
      '1 appel stratégique / mois',
      'Statistiques premium',
      'Support premium (sous 24 heures, canal privé Slack)'
    ],
    included: [true, true, true, true, true, true, true, true, true, true],
  }
} as const;

import React, { useState, useEffect } from 'react';
import { Search, Plus, Trash2, Loader2, TrendingUp, Users, BarChart3, RefreshCw, BadgeCheck, Target, Lock } from 'lucide-react';
import { translations } from '../../translations';
import { supabase } from '../../lib/supabase';
import { hikerApi } from '../../services/hikerApi';
import { imageService } from '../../services/imageService';
import { createCheckoutSession } from '../../lib/stripe';

interface TikTokProps {
  isDarkMode: boolean;
  language: string;
}

interface TikTokAccount {
  id: string;
  name: string;
  username: string;
  avatar: string;
  followers: string;
  following: string;
  posts: number;
  is_verified: boolean;
  is_private: boolean;
  biography: string;
  follower_count: number;
  following_count: number;
  media_count: number;
  follower_history: Array<{
    date: string;
    count: number;
    gains: number;
  }>;
  created_at: string;
  updated_at: string;
  subscription_active: 'inactive' | 'active' | 'FREE';
}

export const TikTok: React.FC<TikTokProps> = ({ isDarkMode, language }) => {
  const [accounts, setAccounts] = useState<TikTokAccount[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAccount, setSelectedAccount] = useState<TikTokAccount | null>(null);
  const [isUpdating, setIsUpdating] = useState<Record<string, boolean>>({});
  const [isAnnual, setIsAnnual] = useState(true);
  const [selectedTab, setSelectedTab] = useState('overview');
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const t = translations[language as keyof typeof translations];

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      setIsLoading(true);
      // For now, we'll use mock data since TikTok accounts table doesn't exist yet
      const mockAccounts: TikTokAccount[] = [
        {
          id: '1',
          name: 'TikTok Creator 1',
          username: '@creator1',
          avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
          followers: '125K',
          following: '891',
          posts: 342,
          is_verified: true,
          is_private: false,
          biography: 'Content creator on TikTok',
          follower_count: 125000,
          following_count: 891,
          media_count: 342,
          follower_history: [
            { date: '2024-03-01', count: 120000, gains: 0 },
            { date: '2024-03-02', count: 122000, gains: 2000 },
            { date: '2024-03-03', count: 125000, gains: 5000 },
          ],
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          subscription_active: 'inactive'
        }
      ];
      
      setAccounts(mockAccounts);
      if (mockAccounts.length > 0) {
        setSelectedAccount(mockAccounts[0]);
      }
    } catch (err) {
      console.error('Error loading TikTok accounts:', err);
      setError('Failed to load TikTok accounts');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddAccount = async (username: string) => {
    // Mock implementation for now
    console.log('Adding TikTok account:', username);
    setShowAddModal(false);
  };

  const handleUpdateAccount = async (accountId: string) => {
    try {
      setIsUpdating(prev => ({ ...prev, [accountId]: true }));
      // Mock update for now
      console.log('Updating TikTok account:', accountId);
    } catch (err) {
      console.error('Error updating TikTok account:', err);
      setError('Failed to update TikTok account');
    } finally {
      setIsUpdating(prev => ({ ...prev, [accountId]: false }));
    }
  };

  const handleDeleteAccount = async (accountId: string) => {
    try {
      // Mock delete for now
      console.log('Deleting TikTok account:', accountId);
      setAccounts(prev => prev.filter(acc => acc.id !== accountId));
      if (selectedAccount?.id === accountId) {
        setSelectedAccount(accounts.find(acc => acc.id !== accountId) || null);
      }
    } catch (err) {
      console.error('Error deleting TikTok account:', err);
      setError('Failed to delete TikTok account');
    }
  };

  const filteredAccounts = accounts.filter(account =>
    account.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    account.username.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const formatNumber = (num: number | string) => {
    const value = typeof num === 'string' ? parseInt(num.replace(/[^0-9]/g, ''), 10) : num;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const calculateGrowthRate = (account: TikTokAccount) => {
    if (account.follower_history.length < 2) return 0;
    
    const firstEntry = account.follower_history[0];
    const lastEntry = account.follower_history[account.follower_history.length - 1];
    
    return lastEntry.count - firstEntry.count;
  };

  const subscriptionStatus = selectedAccount?.subscription_active || 'inactive';
  const hasActiveSubscription = subscriptionStatus === 'active' || subscriptionStatus === 'FREE';
  const isFreeSubscription = subscriptionStatus === 'FREE';

  return (
    <div className="flex h-screen overflow-hidden">
      {/* TikTok Accounts List Sidebar */}
      <div className={`w-72 border-r h-screen overflow-hidden flex flex-col ${
        isDarkMode 
          ? 'bg-[#121212] border-[#2b2b2b]' 
          : 'bg-white border-[#e5e7eb]'
      }`}>
        <div className="p-3 space-y-3">
          <div className="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className={`flex-shrink-0 ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-.04-.1z"/>
            </svg>
            <h1 className={`text-lg font-semibold ${
              isDarkMode ? 'text-gray-200' : 'text-gray-900'
            }`}>
              TikTok
            </h1>
          </div>
          
          <button
            onClick={() => setShowAddModal(true)}
            className="w-full bg-orange-500 text-white rounded-lg py-2 flex items-center justify-center gap-1.5 hover:bg-orange-600 transition-colors text-[13px] font-medium"
          >
            <Plus size={15} strokeWidth={2.5} />
            <span>Add Account</span>
          </button>
          
          <div className="relative">
            <input
              type="text"
              placeholder="Search accounts..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={`w-full rounded-lg pl-9 pr-4 py-2 text-[13px] placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-orange-500 ${
                isDarkMode 
                  ? 'bg-[#2b2b2b] text-gray-200' 
                  : 'bg-gray-50 text-gray-900'
              }`}
            />
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" strokeWidth={2.3} />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          {error && (
            <div className="mx-3 mb-3 p-3 rounded-lg bg-red-50 text-red-500 text-sm">
              {error}
            </div>
          )}

          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 size={24} className="animate-spin text-gray-400" />
            </div>
          ) : filteredAccounts.length > 0 ? (
            <div className="px-3 space-y-2 pb-4">
              {filteredAccounts.map(account => (
                <button
                  key={account.id}
                  onClick={() => setSelectedAccount(account)}
                  className={`w-full p-2 rounded-lg transition-colors flex items-center gap-3 group ${
                    selectedAccount?.id === account.id 
                      ? isDarkMode ? 'bg-[#1c1c1c]' : 'bg-gray-50'
                      : ''
                  } ${
                    isDarkMode 
                      ? 'hover:bg-[#1c1c1c]' 
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <div className="w-10 h-10 rounded-full bg-gray-100 overflow-hidden flex-shrink-0">
                    <img
                      src={account.avatar || 'https://via.placeholder.com/150'}
                      alt={account.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      crossOrigin="anonymous"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <div className={`text-[13px] font-medium ${
                        isDarkMode ? 'text-gray-200' : 'text-gray-900'
                      }`}>
                        {account.name}
                      </div>
                      {account.is_verified && (
                        <BadgeCheck size={12} className="text-blue-500" />
                      )}
                      {account.is_private && (
                        <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${
                          isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-700'
                        }`}>
                          Private
                        </span>
                      )}
                    </div>
                    <div className={`text-[12px] ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-500'
                    } text-left`}>
                      {account.username}
                    </div>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUpdateAccount(account.id);
                    }}
                    disabled={isUpdating[account.id]}
                    className={`p-1 rounded transition-colors ${
                      isUpdating[account.id] ? 'animate-spin' : ''
                    } ${
                      isDarkMode
                        ? 'text-gray-500 hover:text-gray-300'
                        : 'text-gray-400 hover:text-gray-600'
                    }`}
                  >
                    <RefreshCw size={12} />
                  </button>
                </button>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center py-12">
              <p className={`text-sm ${
                isDarkMode ? 'text-gray-400' : 'text-gray-500'
              }`}>
                No TikTok accounts found
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 overflow-y-auto p-4 md:p-8">
        {selectedAccount ? (
          <div className="space-y-6">
            {/* Account Header */}
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <img
                  src={selectedAccount.avatar || 'https://via.placeholder.com/150'}
                  alt={selectedAccount.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <h2 className={`font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>
                      {selectedAccount.name}
                    </h2>
                    {selectedAccount.is_verified && (
                      <BadgeCheck 
                        size={16} 
                        className="text-blue-500" 
                        strokeWidth={2.5} 
                      />
                    )}
                    {selectedAccount.is_private && (
                      <span className={`text-xs font-medium px-1.5 py-0.5 rounded-full ${
                        isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-700'
                      }`}>
                        Private
                      </span>
                    )}
                  </div>
                  <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {selectedAccount.username}
                  </p>
                  {selectedAccount.biography && (
                    <p className={`mt-1 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      {selectedAccount.biography}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div className="border-b border-gray-200 dark:border-gray-800 overflow-x-auto">
              <nav className="flex gap-6 whitespace-nowrap">
                <button
                  onClick={() => hasActiveSubscription && setSelectedTab('overview')}
                  className={`pb-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${
                    !hasActiveSubscription ? 'opacity-50 cursor-not-allowed' : ''
                  } ${
                    selectedTab === 'overview'
                      ? 'border-orange-500 text-orange-500'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                  }`}
                >
                  {!hasActiveSubscription && <Lock size={12} />}
                  Vue d'ensemble
                </button>
                <button
                  onClick={() => setSelectedTab('plans')}
                  className={`pb-4 text-sm font-medium border-b-2 transition-colors ${
                    selectedTab === 'plans'
                      ? 'border-orange-500 text-orange-500'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
                  }`}
                >
                  Plans
                </button>
              </nav>
            </div>

            {/* Tab Content */}
            <div className="pt-4">
              {selectedTab === 'overview' && hasActiveSubscription && (
                <div className="space-y-6">
                  {/* Stats Cards */}
                  <div className="grid grid-cols-3 gap-4">
                    <div className={`p-4 rounded-lg border ${
                      isDarkMode 
                        ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                        : 'bg-white border-[#e5e7eb]'
                    }`}>
                      <div className={`text-[13px] mb-1 ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-500'
                      }`}>Followers</div>
                      <div className={`text-xl font-semibold ${
                        isDarkMode ? 'text-gray-200' : 'text-gray-900'
                      }`}>{formatNumber(selectedAccount.follower_count)}</div>
                    </div>
                    <div className={`p-4 rounded-lg border ${
                      isDarkMode 
                        ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                        : 'bg-white border-[#e5e7eb]'
                    }`}>
                      <div className={`text-[13px] mb-1 ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-500'
                      }`}>Growth Rate</div>
                      <div className={`text-xl font-semibold ${
                        calculateGrowthRate(selectedAccount) >= 0 
                          ? 'text-emerald-500' 
                          : 'text-red-500'
                      }`}>
                        {calculateGrowthRate(selectedAccount) >= 0 ? '+' : ''}
                        {Math.abs(calculateGrowthRate(selectedAccount)).toLocaleString()}
                      </div>
                    </div>
                    <div className={`p-4 rounded-lg border ${
                      isDarkMode 
                        ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                        : 'bg-white border-[#e5e7eb]'
                    }`}>
                      <div className={`text-[13px] mb-1 ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-500'
                      }`}>Videos</div>
                      <div className={`text-xl font-semibold ${
                        isDarkMode ? 'text-gray-200' : 'text-gray-900'
                      }`}>{formatNumber(selectedAccount.media_count)}</div>
                    </div>
                  </div>

                  {/* Follower Evolution Chart */}
                  <div className={`p-6 rounded-lg border ${
                    isDarkMode 
                      ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                      : 'bg-white border-[#e5e7eb]'
                  }`}>
                    <div className="flex items-center justify-between mb-6">
                      <h2 className={`text-lg font-semibold ${
                        isDarkMode ? 'text-gray-200' : 'text-gray-900'
                      }`}>Follower Evolution</h2>
                      <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${
                        calculateGrowthRate(selectedAccount) >= 0
                          ? 'text-emerald-600 bg-emerald-50' 
                          : 'text-red-600 bg-red-50'
                      }`}>
                        <TrendingUp size={14} strokeWidth={2.5} />
                        <span className="text-[13px] font-medium">
                          {calculateGrowthRate(selectedAccount) >= 0 ? '+' : ''}
                          {Math.abs(calculateGrowthRate(selectedAccount)).toLocaleString()}
                        </span>
                      </div>
                    </div>
                    
                    <div className="h-[300px] flex items-center justify-center">
                      <p className={`text-sm ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-500'
                      }`}>
                        Chart coming soon...
                      </p>
                    </div>
                  </div>
                </div>
              )}
              
              {selectedTab === 'overview' && !hasActiveSubscription && (
                <div className={`p-8 rounded-lg border text-center ${
                  isDarkMode 
                    ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                    : 'bg-white border-[#e5e7eb]'
                }`}>
                  <Lock size={48} className={`mx-auto mb-4 ${
                    isDarkMode ? 'text-gray-600' : 'text-gray-400'
                  }`} />
                  <h3 className={`text-lg font-semibold mb-2 ${
                    isDarkMode ? 'text-gray-200' : 'text-gray-900'
                  }`}>
                    Fonctionnalité Premium
                  </h3>
                  <p className={`text-sm mb-6 ${
                    isDarkMode ? 'text-gray-400' : 'text-gray-600'
                  }`}>
                    Pour accéder aux statistiques détaillées TikTok, vous devez souscrire à un plan.
                  </p>
                  <button
                    onClick={() => setSelectedTab('plans')}
                    className="px-6 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors"
                  >
                    Voir les plans
                  </button>
                </div>
              )}
              
              {selectedTab === 'plans' && !isFreeSubscription && (
                <div className={`p-6 rounded-lg border ${
                  isDarkMode 
                    ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                    : 'bg-white border-[#e5e7eb]'
                }`}>
                  <div className="flex justify-between items-center mb-6">
                    <h2 className={`text-lg font-semibold ${
                      isDarkMode ? 'text-gray-200' : 'text-gray-900'
                    }`}>TikTok Growth Plans</h2>
                    
                    <div className={`inline-flex rounded-lg p-0.5 ${
                      isDarkMode 
                        ? 'bg-[#2b2b2b]' 
                        : 'bg-gray-100 border border-gray-200'
                    }`}>
                      <button
                        onClick={() => setIsAnnual(false)}
                        className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                          !isAnnual
                            ? isDarkMode
                              ? 'bg-[#1c1c1c] text-white'
                              : 'bg-white text-gray-900 shadow-sm border border-gray-200'
                            : isDarkMode
                              ? 'text-gray-400'
                              : 'text-gray-500'
                        }`}
                      >
                        Mensuel
                      </button>
                      <button
                        onClick={() => setIsAnnual(true)}
                        className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                          isAnnual
                            ? isDarkMode
                              ? 'bg-[#1c1c1c] text-white'
                              : 'bg-white text-gray-900 shadow-sm border border-gray-200'
                            : isDarkMode
                              ? 'text-gray-400'
                              : 'text-gray-500'
                        }`}
                      >
                        Annuel
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    {Object.entries(products).map(([planName, product]) => (
                      <div
                        key={planName}
                        className={`rounded-xl border p-6 relative ${
                          isDarkMode 
                            ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                            : 'bg-white border-[#e5e7eb]'
                        }`}
                      >
                        {product.popular && (
                          <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                            <div className="bg-orange-500 text-white text-[11px] font-medium px-3 py-1 rounded-full">
                              Populaire
                            </div>
                          </div>
                        )}

                        <div className="mb-4">
                          <h3 className={`text-lg font-semibold ${
                            isDarkMode ? 'text-gray-200' : 'text-gray-900'
                          }`}>{planName}</h3>
                          <div className="mt-1 mb-4">
                            <span className={`text-2xl font-bold ${
                              isDarkMode ? 'text-gray-200' : 'text-gray-900'
                            }`}>
                              {isAnnual 
                                ? product.EUR.annual.price
                                : product.EUR.monthly.price
                              }
                            </span>
                            <span className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
                              /mois
                            </span>
                          </div>
                        </div>

                        <div className="space-y-3 mb-6">
                          {product.features.map((feature, index) => (
                            <div key={index} className="flex items-center gap-2">
                              <BadgeCheck 
                                size={14} 
                                className="text-[#F98F61]" 
                                strokeWidth={2.5} 
                              />
                              <span className={`text-[13px] ${
                                isDarkMode ? 'text-gray-300' : 'text-gray-600'
                              }`}>{feature}</span>
                            </div>
                          ))}
                        </div>

                        <button
                          onClick={async () => {
                            try {
                              setIsCheckingOut(true);
                              const priceId = isAnnual 
                                ? product.EUR.annual.priceId 
                                : product.EUR.monthly.priceId;
                              await createCheckoutSession(priceId, product.mode, 'tiktok-tracking', false);
                            } catch (error) {
                              console.error('Error starting TikTok checkout:', error);
                              setIsCheckingOut(false);
                            }
                          }}
                          disabled={isCheckingOut}
                          className={`w-full mt-6 rounded-lg py-2 text-[13px] font-medium transition-colors ${
                            isDarkMode
                              ? 'bg-[#2b2b2b] text-gray-300 hover:bg-[#333333]'
                              : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                          } disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2`}
                        >
                          {isCheckingOut ? (
                            <>
                              <Loader2 size={14} className="animate-spin" />
                              <span>Chargement...</span>
                            </>
                          ) : (
                            'Commencer'
                          )}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {selectedTab === 'plans' && isFreeSubscription && (
                <div className={`p-6 rounded-lg border ${
                  isDarkMode 
                    ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
                    : 'bg-white border-[#e5e7eb]'
                }`}>
                  <p className={`text-sm leading-relaxed ${
                    isDarkMode ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    Vous bénéficiez actuellement d'une offre personnalisée et exclusive pour TikTok.
                    <br />
                    Pour toute demande concernant votre abonnement, vous pouvez directement contacter votre Account Manager.
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="text-center mt-12">
            <p className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
              Select a TikTok account to view details
            </p>
          </div>
        )}
      </div>

      {/* Add Account Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className={`w-full max-w-md rounded-lg p-6 ${
            isDarkMode ? 'bg-[#1c1c1c]' : 'bg-white'
          }`}>
            <div className="flex justify-between items-center mb-6">
              <h3 className={`text-xl font-semibold ${
                isDarkMode ? 'text-gray-200' : 'text-gray-900'
              }`}>
                Add TikTok Account
              </h3>
              <button 
                onClick={() => setShowAddModal(false)}
                className={`p-1 rounded-full ${
                  isDarkMode ? 'hover:bg-[#2b2b2b]' : 'hover:bg-gray-100'
                }`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6L6 18"></path>
                  <path d="M6 6l12 12"></path>
                </svg>
              </button>
            </div>

            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target as HTMLFormElement);
              const username = formData.get('username') as string;
              handleAddAccount(username);
            }} className="space-y-4">
              <div>
                <label className={`block text-sm font-medium mb-1.5 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  TikTok Username
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="username"
                    placeholder="@username"
                    className={`w-full rounded-lg pl-10 pr-4 py-2.5 text-sm ${
                      isDarkMode
                        ? 'bg-[#2b2b2b] text-gray-200 border-[#2b2b2b]'
                        : 'bg-gray-50 text-gray-900 border-gray-200'
                    } focus:outline-none focus:ring-2 focus:ring-orange-500`}
                    required
                  />
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-.04-.1z"/>
                  </svg>
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className={`px-4 py-2 rounded-lg text-sm ${
                    isDarkMode 
                      ? 'text-gray-300 hover:bg-[#2b2b2b]' 
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors flex items-center gap-2"
                >
                  <Plus size={14} />
                  Add Account
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};